import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=4f23390c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f23390c')) {
      api.createRecord('4f23390c', component.options)
    } else {
      api.reload('4f23390c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=4f23390c&", function () {
      api.rerender('4f23390c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21l0gCnLvYxnO/JS/childrenage.vue"
export default component.exports